export default __webpack_public_path__ + "static/media/group-7799.0de677bb.svg";